export default __webpack_public_path__ + "static/media/change-mode.a911ec6d.gif";